export default __webpack_public_path__ + "static/media/cheffy_hero.4ff7f36b.jpg";